import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ActivityControlService = {
    list: async (filters) => axios.post(API_URL + "/activity-control/list", filters).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_URL + "/activity-control/" + id).then(({data}) => data).catch((err) => { throw err }),
    create: async (model) => axios.post(API_URL + "/activity-control", model).then(({data}) => data).catch((err) => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/activity-control/" + id, model).then(({data}) => data).catch((err) => { throw err }),
    getFollowUp: async (filters) => axios.post(API_URL + "/activity-control/get/follow-up", filters).then(({data}) => data).catch((err) => { throw err }),
};

export default ActivityControlService;